<div class="text-top" *ngIf="isSuperAdmin()">
    <span>Agente {{ agent.firstName }} {{ agent.lastName }}</span>
</div>

<div class="agent-navigation-bar mb-3" *ngIf="isSuperAdmin()">
    <div class="d-flex gap-4">
        <span [ngClass]="{'active' : componentIndex === 0}" (click)="showComponent(0)"  style="cursor: pointer">Dashboard</span>
        <span [ngClass]="{'active' : componentIndex === 1}" (click)="showComponent(1)"  style="cursor: pointer">Informazioni</span>
        <span [ngClass]="{'active' : componentIndex === 2}" (click)="showComponent(2)"  style="cursor: pointer">Sicurezza</span>
        <span [ngClass]="{'active' : componentIndex === 3}" (click)="showComponent(3)"  style="cursor: pointer">Società</span>
        <span [ngClass]="{'active' : componentIndex === 4}" (click)="showComponent(4)"  style="cursor: pointer">Fatture</span>
    </div>
</div>

<div class="agent-navigation-bar mb-3" *ngIf="isAgent()">
    <div class="d-flex gap-4">
        <span [ngClass]="{'active' : componentIndex === 1}" (click)="showComponent(1)"  style="cursor: pointer">Informazioni</span>
        <span [ngClass]="{'active' : componentIndex === 4}" (click)="showComponent(4)"  style="cursor: pointer">Fatture</span>
    </div>
</div>

<div class="agent-container">
    <ng-container [ngSwitch]="componentIndex">
        <!--Dashboard-->
        <ng-container *ngSwitchCase="0">
            <app-company-list [alternativeTable]="true"></app-company-list>
        </ng-container>
        <!--Informazioni-->
        <ng-container *ngSwitchCase="1">
            <div class="welldone-card">
                <div class="welldone-card-header">
                    Informazioni agente
                </div>
                <div class="welldone-card-body">
                    <div class="container-fluid">
                        <div class="row mb-3">
                            <div class="col-4">Foto profilo</div>
                            <div class="col-8">
                                <div class="edit-profile-pic shadow">
                                    <img [src]="agent.image && agent.image !== '' ? agent.image : 'assets/profilePic.png' " alt="profile picture"/>
                                    <label class="edit-icon pencil shadow">
                                        <img src="assets/icons/pencil-fill.svg" alt="edit"/>
                                        <input type="file" accept=".png, .jpg, .jpeg" id="edit-pencil"
                                               (change)="updateProfilePicture($event)"/>
                                    </label>
                                    <div class="edit-icon cross shadow" (click)="removeProfileImage()">
                                        <img src="assets/icons/x-lg.svg" alt="delete"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Nome e Cognome</div>
                            <div class="col-8">
                                <div class="row">
                                    <div class="col-sm-6"><input type="text" class="form-control form-control-solid"
                                                                 [(ngModel)]="agent.firstName"/></div>
                                    <div class="col-sm-6"><input type="text" class="form-control form-control-solid"
                                                                 [(ngModel)]="agent.lastName"/></div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Ragione Sociale</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.businessName"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Telefono</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.phone"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Email</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.email"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Codice fiscale</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.fiscalCode"/>
                            </div>
                        </div>
                        <div class="row mb-2 mt-4">
                            <div class="col-12 fw-semibold text-muted">Documento d'identità</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Numero documento</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.documentNumber"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Fronte carta d'identità</div>
                            <div class="col-8">
                                <div class="d-flex flex-column gap-2">
                                    <a *ngIf="agent.documentUrlFront" class="btn welldone-btn-gray align-self-start"
                                       [href]="agent.documentUrlFront" target="_blank" rel="noopener noreferrer">
                                        Visualizza documento
                                    </a>
                                    <label class="btn welldone-btn-gray align-self-start mb-0">
                                        Carica nuovo fronte
                                        <input type="file" class="d-none" accept="image/*,application/pdf"
                                               (change)="updateDocumentFront($event)"/>
                                    </label>
                                    <button *ngIf="agent.documentUrlFront" type="button" class="btn btn-link text-danger p-0 align-self-start"
                                            (click)="removeDocumentFront()">
                                        Rimuovi documento
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Retro carta d'identità</div>
                            <div class="col-8">
                                <div class="d-flex flex-column gap-2">
                                    <a *ngIf="agent.documentUrlBack" class="btn welldone-btn-gray align-self-start"
                                       [href]="agent.documentUrlBack" target="_blank" rel="noopener noreferrer">
                                        Visualizza documento
                                    </a>
                                    <label class="btn welldone-btn-gray align-self-start mb-0">
                                        Carica nuovo retro
                                        <input type="file" class="d-none" accept="image/*,application/pdf"
                                               (change)="updateDocumentBack($event)"/>
                                    </label>
                                    <button *ngIf="agent.documentUrlBack" type="button" class="btn btn-link text-danger p-0 align-self-start"
                                            (click)="removeDocumentBack()">
                                        Rimuovi documento
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2 mt-4">
                            <div class="col-12 fw-semibold text-muted">Dati fiscali e fatturazione</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Partita IVA</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.vat"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">SDI</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.sdi"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">PEC</div>
                            <div class="col-8">
                                <input type="email" class="form-control form-control-solid"
                                       [(ngModel)]="agent.pec"/>
                            </div>
                        </div>
                        <div class="row mb-2 mt-4">
                            <div class="col-12 fw-semibold text-muted">Indirizzo</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Indirizzo</div>
                            <div class="col-8">
                                <div class="row g-2">
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control form-control-solid"
                                               [(ngModel)]="agent.address" placeholder="Via"/>
                                    </div>
                                    <div class="col-sm-4">
                                        <input type="text" class="form-control form-control-solid"
                                               [(ngModel)]="agent.addressNumber" placeholder="N. civico"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">CAP</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.zip"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Provincia e Città</div>
                            <div class="col-8">
                                <div class="row g-2">
                                    <div class="col-sm-4">
                                        <input type="text" class="form-control form-control-solid"
                                               [(ngModel)]="agent.province" placeholder="Provincia"/>
                                    </div>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control form-control-solid"
                                               [(ngModel)]="agent.city" placeholder="Città"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2 mt-4">
                            <div class="col-12 fw-semibold text-muted">Modalità di pagamento</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Istituto di credito</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.bank"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">IBAN</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid text-uppercase"
                                       [(ngModel)]="agent.iban"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Intestatario C/C (persona)</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.accountHolderPerson"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Intestatario C/C (azienda)</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.accountHolderCompany"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Telefono pagamenti</div>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-solid"
                                       [(ngModel)]="agent.paymentPhone"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4">Email pagamenti</div>
                            <div class="col-8">
                                <input type="email" class="form-control form-control-solid"
                                       [(ngModel)]="agent.paymentEmail"/>
                            </div>
                        </div>
                        <ng-container *ngIf="isSuperAdmin()">
                            <div class="row mb-3">
                                <div class="col-4">% Commissione 1° Anno</div>
                                <div class="col-8">
                                    <input type="text" class="form-control form-control-solid"
                                           [(ngModel)]="agent.agentCommissionPercentFirstYear"/>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-4">% Commissione Standard</div>
                                <div class="col-8">
                                    <input type="text" class="form-control form-control-solid"
                                           [(ngModel)]="agent.agentCommissionPercent"/>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="welldone-card-footer">
                    <button class="btn btn-primary" (click)="updateAgent()"> Aggiorna </button>
                </div>
            </div>
        </ng-container>
        <!--Sicurezza-->
        <ng-container *ngSwitchCase="2">
            <div class="welldone-card mb-5">
                <div class="welldone-card-header">
                    Codice agente
                </div>
                <div class="welldone-card-body">
                    <span class="title">Codice gente</span>
                    <span class="subtitle">{{ agent.referralCode }}</span>
                </div>
            </div>
            <div class="welldone-card mb-5">
                <div class="welldone-card-header">
                    Credenziali di accesso
                </div>
                <div class="welldone-card-body">
                    <div class="d-flex flex-column align-items-start dotted-bottom">
                        <span class="title">Email</span>
                        <span class="subtitle">{{agent.email}}</span>
                    </div >
                    <div class="d-flex flex-column align-items-start pt-4">
                        <span class="title">Password</span>
                        <span class="subtitle"> ******** </span>
                    </div>
                </div>
            </div>
            <div class="welldone-card">
                <div class="welldone-card-header">
                    Stato dell'account
                </div>
                <div class="welldone-card-body">
                    <div class="link link-warning align-items-center gap-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                        </svg>
                        Desideri disattivare questo profilo
                    </div>
                </div>
                <div class="welldone-card-footer">
                    <button class="btn welldone-btn-danger"
                    (click)="disableAgent(agent.id!)">
                        Disattiva
                    </button>
                </div>
            </div>
        </ng-container>
        <!--Società-->
        <ng-container *ngSwitchCase="3">
            <app-company-list [alternativeTable]="true" [showLabels]="false"></app-company-list>
        </ng-container>
        <!--Fatture-->
        <ng-container *ngSwitchCase="4">
            <ui-table
                    #invoicesTable
                    table-title="Fatture"
                    table-description="Riepilogo delle fatture che Well Done ha emesso nei vostri confronti.">
                <ng-template #customHeader>
                <tr>
                    <th>
                        Numero
                    </th>
                    <th>
                        Data
                    </th>
                    <th>
                        Stato
                    </th>
                    <th>
                        Metodo di pagamento
                    </th>
                    <th>
                        Importo
                    </th>
                    <th>
                        Report
                    </th>
                    <th>
                        Fattura
                    </th>
                    <th *ngIf="isAgent()"></th>
                </tr>
                </ng-template>
                <ng-template #customRow let-row="row">
                    <tr>
                        <td>
                            {{ row.number }}
                        </td>
                        <td>
                            {{ row.createdAt | date: 'dd/MM/yyyy' }}
                        </td>
                        <td>
                            <span *ngIf="row.paymentStatus === 'paid'" class="badge badge-success"> Pagato </span>
                            <span *ngIf="row.paymentStatus !== 'paid'" class="badge badge-error"> Non pagato </span>
                        </td>
                        <td>
                            <span> {{ paymentTypes(row.paymentMethod) }} </span>
                        </td>
                        <td>
                            {{ row.amount }}€
                        </td>
                        <td >
                            <a class="btn welldone-btn-gray" [href]="row.url ?? 'javascript:void(0);' "> {{ row.url ? 'Report' : 'Non disponibile al momento' }} </a>
                        </td>
                        <td>    
                            <a class="btn welldone-btn-gray" [href]="row.fattureInCloudDocumentUrl ?? 'javascript:void(0);' "> {{ row.fattureInCloudDocumentUrl ? 'Fattura' : 'Non disponibile al momento' }} </a>
                        </td>
                        <td *ngIf="isAgent()">
                            <ng-container *ngIf="row.paymentStatus !== 'paid'; else paid">
                                <button class="btn welldone-btn-danger" (click)="markAsPaid(row.id)"> Imposta come pagato </button>
                            </ng-container>
                            <ng-template #paid>
                                <button class="btn welldone-btn-success"> Pagato </button>
                            </ng-template>
                        </td>
                    </tr>
                </ng-template>

            </ui-table>
        </ng-container>
    </ng-container>
</div>
